import React from "react";
import { NavLink } from "react-router-dom";
import '../../Cile/Cile-Content/Cile-Content.scss';

    const PlaylistTypes = () => {

        const cards = [
            {
                nome: "Podcasts",
                link: "/multimidia/playlist/podcasts/lista",
                icon: "fas fa-podcast text-primary",
            },
            {
                nome: "Vídeos",
                link: "/multimidia/playlist/videos/lista",
                icon: "fas fa-film text-purple",
            },
        ]

        return (
            <div className="cile-remessas">
                <div className="row">
                    <div className="col-8 text-left">
                        <h2 className="title-1">Playlists</h2>
                    </div>
                    <div className="col-12 py-2">
                    <div className="row opcoes-home">
                        {cards.map((item) => {
                            return (
                                <div className="col-12 col-lg-4 py-3">
                                    <NavLink to={item.link}>
                                        <div className="card card-home">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className='col-12'>
                                                        <i className={`fas ${item.icon} fa-2x`}></i>
                                                    </div>
                                                    <div className='col-12 pt-2 nome-item'>
                                                        {item.nome}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            )
                        })}
                    </div>
                    </div>
                </div>
            </div>
        )
    }


export default PlaylistTypes;